export const maskCPF = (value) => {
  return value
    .replace(/\D/g, "") // Remove tudo que não é dígito
    .replace(/(\d{3})(\d)/, "$1.$2") // Coloca ponto após os 3 primeiros dígitos
    .replace(/(\d{3})(\d)/, "$1.$2") // Coloca ponto após os 6 primeiros dígitos
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // Coloca hífen antes dos 2 últimos dígitos
};

export const maskPhone = (value) => {
  return value
    .replace(/\D/g, "") // Remove tudo que não é dígito
    .replace(/(\d{2})(\d)/, "($1) $2") // Coloca parênteses em volta dos 2 primeiros dígitos
    .replace(/(\d{5})(\d)/, "$1-$2") // Coloca hífen depois do 5º dígito
    .substring(0, 15); // Limita o tamanho
};
